import reframe from 'nike-re-framejs';

import { trackEvent } from 'nike-ui/src/analytics/gtm';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import { pipe } from '@/common/util';

const nikeonePageMap = {
    'page::home': 'Homepage',
    'page::superoffer': 'Superponuka',
    nikeOne: 'Ponuka',
    nikeOneLive: 'Ponuka',
    nikeOneResults: 'Ponuka',
    nikeOnePrematchDetail: 'Detail zapasu',
    nikeOneLiveDetail: 'Detail zapasu',
    nikeOneTournament: 'Detail turnaja (id)',
    nikeOneMenuItemTournament: 'Detail turnaja',
    article: 'Clanok',
    marketingArticle: 'Clanok',
    'page::analysisDetail': 'Clanok',
    favoritesLive: 'Moje Live',
    'page:nikeOneFav': 'Moje Kurzy',
    'page::favoritesHistoria': 'Moja Historia',
    'page::myTicketsOverview': 'Tikety podane',
    'page::savedTickets': 'Tikety ulozene',
    'page::ticketsStore': 'Tikety inspiracie'
};

const svetHierPageMap = {
    'kasino:lobby': 'Casino',
    'kasino:game-detail': 'Detail hry',
    'kasino:iForium:gameCategory': 'Zoznam hier iForium',
    'kasino:RedTiger:gameCategory': 'Zoznam hier RedTiger'
};

export const TOURNAMENT = 'cl-turnaje';
export const CHAT = 'Chat';

export const fireGAEvent = (category, action, label, value) => {
    // ak je category 'novy' route object
    if (category && category.name && category.path) {
        category = category.name;
    }

    category = guessNikeoneCategory(category) || guessSvetHierCategory(category) || category;

    if (category === 'Ponuka') {
        return;
    }

    return trackEvent(category, action, label, value);
};

export const togglePickAction = selected => (selected ? 'Odobranie z tiketu' : 'Pridanie na tiket');

const processPageName = pageName => {
    const validPage = pageName && pageName.length && pageName[0] === pageName[0].toLowerCase();
    if (!validPage) return null;
    if (pageName === CURRENT_PAGE) return reframe.db$.getValue().getIn(['route']).name;
    return pageName;
};

const getFromPageMap = map => page => (page ? map[page] : null);

const guessNikeoneCategory = pipe(processPageName, getFromPageMap(nikeonePageMap));
const guessSvetHierCategory = pipe(processPageName, getFromPageMap(svetHierPageMap));

export const _testOnly = {
    guessNikeoneCategory,
    guessSvetHierCategory
};
